import React from 'react';
import LoaderSvg from '@components/Loader/LoaderSvg';

import './TranscriptionLoader.less';

export default function TranscriptionLoader() {
  return (
    <div className="media_viewer_transcription-loader">
      <div className="media_viewer_transcription-loader-icon">
        <LoaderSvg
          spinSize={98}
          circleColor="rgba(255, 255, 255, 0.11)"
          circleStrokeColor="#3553DB"
        />
      </div>
      <div className="media_viewer_transcription-loader-title">
        Generating transcription…
      </div>
      <div className="media_viewer_transcription-loader-text">
        <p>
          Processing time may vary based on the length of the media. You can
          close this panel while the transcription is being generated.
        </p>{' '}
        <p>We’ll notify you when it’s ready.</p>
      </div>
    </div>
  );
}
